import React, { createContext, useState, useContext } from 'react';

const ConsentContext = createContext();

export const ConsentProvider = ({ children }) => {
  const [consentAccepted, setConsentAccepted] = useState(false);

  return (
    <ConsentContext.Provider value={{ consentAccepted, setConsentAccepted }}>
      {children}
    </ConsentContext.Provider>
  );
};

export const useConsent = () => useContext(ConsentContext);